import axios from "axios";
import { API_ROUTE } from "../Constants/gateway";
import { auth_user } from "./util";

const gateWay = axios.create({
  baseURL: API_ROUTE,
  timeout: 20000,
});

// Request Interceptor
gateWay.interceptors.request.use(function (config) {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${auth_user().token}`,
  };
  return config;
});

// Response Interceptor
gateWay.interceptors.response.use(
  (res) => {
    if (res?.data?.error === "TokenExpiredError") {
      localStorage.clear();
      window.location.href = "/";
    }
    return res;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error); // ✅ reject error properly
  },
);

export default gateWay;

// For login (no auth)
export const authenticator = axios.create({
  baseURL: API_ROUTE,
  timeout: 20000,
});
